import React from "react";
import { Routes, Route } from "react-router-dom";
import BranchTallyCreateScreen from "screens/App/CRM/BranchTally/BranchTallyCreateScreen";
import BranchTallyDetailScreen from "screens/App/CRM/BranchTally/BranchTallyDetailScreen";
import BranchTallyListScreen from "screens/App/CRM/BranchTally/BranchTallyListScreen";
import BranchTallyPrintScreen from "screens/App/CRM/BranchTally/BranchTallyPrintScreen";
import BranchTallyScanScreen from "screens/App/CRM/BranchTally/BranchTallyScanScreen";
import BranchTallyUpdateScreen from "screens/App/CRM/BranchTally/BranchTallyUpdateScreen";


const BranchTallyRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<BranchTallyListScreen />} />
      <Route path="create" element={<BranchTallyCreateScreen />} />
      <Route path="scan/:id" element={<BranchTallyScanScreen />} />
      <Route path=":id/detail" element={<BranchTallyDetailScreen />} />
      <Route path=":id/update" element={<BranchTallyUpdateScreen />} />
      <Route path="print/:id" element={<BranchTallyPrintScreen />} />
    </Routes>
  );
};

export default BranchTallyRouter;
